import React, { useState, useEffect, Fragment } from "react";
import {
  Card,
  Layout,
  Row,
  Col,
  Button,
  Input,
  Table,
  message,
  Space,
  DatePicker,
  Modal,
  Select,
} from "antd";
import { Redirect, Link } from "react-router-dom";
import Axios from "axios";
import moment from "moment";
import { url } from "../../config/global";
import {
  ExportOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import "./SPListGRMaterial.less";
import fileDownload from "js-file-download";

const { Search } = Input;
const { Content } = Layout;
const { Option } = Select;
const { RangePicker } = DatePicker;

function SPListGRMaterial() {
  const [keyword, setKeyword] = useState("");
  const [grmaterials, setGrmaterials] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [totalGR, setTotalGR] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPagesize] = useState(10);
  const [buttonAccess, setButtonAccess] = useState(null);
  const [sort, setSort] = useState({
    sort: "created_at",
    order: "descend",
  });
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [suppliers, setSupplier] = useState([]);
  const [error, setError] = useState(null);
  const [date, setDate] = useState(moment(new Date()));
  const [data, setData] = useState([]);
  const handleSearch = (value) => {
    setKeyword(value);
  };

  useEffect(() => {
    getData(keyword, page, sort, startDate, endDate);
  }, [keyword, page, pageSize, sort, startDate, endDate]);
  const getVendor = async (keyword) => {
    await Axios.get(`${url}/master-supplier/list`, {
      params: {
        keyword,
        columns: ["supplier_code", "supplier_name"],
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setSupplier(res.data.data);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      });
  };
  const handleChangeSelectVendor = (name, value) => {
    const find = suppliers.find((x) => x._id === value.key);
    setError(null);
    setData({
      ...data,
      [`${name}_id`]: value.value,
      [`${name}_label`]: value.label,
      [`${name}_code`]: find.supplier_code,
      [`${name}_name`]: find.supplier_name,
    });

    console.log(value, name, find, "cek woy");
  };
  useEffect(() => {
    const pathname = window.location.pathname.split("/");
    const currentUrl = pathname[1];
    const permissions =
      sessionStorage.getItem("permissions") &&
      JSON.parse(sessionStorage.getItem("permissions"));

    if (permissions) {
      const findPermission = permissions.find(
        (permission) => permission.url === currentUrl
      );

      const findChildPermission = permissions
        .map((child) => {
          return child.children.find(
            (grandChild) => grandChild.url === currentUrl
          );
        })
        .filter((grandChild) => grandChild)[0];

      if (findChildPermission && findChildPermission.children) {
        if (findChildPermission.children) {
          const findButtonAccessChildren = findChildPermission.children
            .filter((x) => x !== null)
            .filter((x) => x.permission_type === "button");
          if (findButtonAccessChildren) {
            setButtonAccess(findButtonAccessChildren.filter((x) => x !== null));
          }
        }
      }

      if (findPermission && findPermission.children) {
        const findButtonAccess = findPermission.children.filter(
          (x) => x.permission_type === "button"
        );
        if (findButtonAccess) {
          setButtonAccess(findButtonAccess);
        }
      }
    }
  }, []);

  const getData = () => {
    setLoading(true);
    Axios.get(`${url}/master-list-gr-material`, {
      params: {
        keyword,
        supplier_code:data.supplier_code,
        columns: [
          "component_item",
          "gr_no",
          "project",
          "storage",
          "dn_no",
          "no_po",
          "description2",
          "description1",
          "packing_slip",
          "line",
          "qty",
        ],
        perpage: pageSize,
        page,
        sort: sort.sort,
        order: sort.order,
        start_date: startDate,
        end_date: endDate,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setGrmaterials(res.data);
        setTotalGR(res.data.total);
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const HandlegetQAD = () => {
    setLoading(true);
    Axios.get(`${url}/soap/get-list-gr`, {
      params: {
        date: moment(date).format("YYYY-M-D"),
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        // message.success(res.data.message);
        Modal.success({
          title: "Success!",
          content: res.data.message,
        });
        getData();
      })
      .catch((err) => {
        if (err.response) {
          // message.error(err.response.data.message);
          Modal.error({
            title: "Error!",
            content: err.response.data.message,
          });
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
        setLoading(false);
      });
  };

  const HandleSendQAD = () => {
    setLoading(true);
    Axios.post(`${url}/soap/send-list-gr`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        console.log(res);
        // Modal.success({
        //   title: "Success!",
        //   content: res.data.message,
        // });

        Modal.info({
          width: 840,
          title: "QAD Feedback!",
          // onOk: () => {
          //   return props.history.push("/gr-material");
          // },
          content: (
            <div>
              <Table
                columns={[
                  {
                    title: "Component Item",
                    dataIndex: "component_item",
                    key: "component_item",
                  },
                  {
                    title: "Send GR Status",
                    dataIndex: "send_gr_status",
                    key: "send_gr_status",
                    render: (status) => {
                      return status ? (
                        <span style={{ color: "green" }}>SUCCESS</span>
                      ) : (
                        <span style={{ color: "red" }}>ERROR</span>
                      );
                    },
                  },
                  {
                    title: "Reason",
                    dataIndex: "send_gr_reason",
                    key: "send_gr_reason",
                  },
                ]}
                pagination={false}
                dataSource={res.data.result}
              />
            </div>
          ),
        });

        getData();
      })
      .catch((err) => {
        if (err.response) {
          // message.error(err.response.data.message);
          Modal.error({
            title: "Error!",
            content: err.response.data.message,
          });
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
        setLoading(false);
      });
  };

  // Di dalam component Anda (contoh: PDListGRMaterial.jsx atau sesuai nama file)

  const exportGRMaterial = () => {
    setLoadingExport(true);
    Axios.get(`${url}/master-list-gr-material/export`, {
      params: {
        keyword: keyword || "",
        columns: columns || [
          "component_item",
          "gr_no",
          "project",
          "storage",
          "dn_no",
          "no_po",
          "description2",
          "description1",
          "packing_slip",
          "line",
          "qty",
        ],
        start_date: startDate || "",
        end_date: endDate || "",
        sort: sort.sort || "created_at",
        order: sort.order || "descend",
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      responseType: "blob",
    })
      .then((res) => {
        fileDownload(
          res.data,
          "Export-List-GR-Material-" + moment().format("YYYY-MM-DD") + ".xlsx"
        );
        message.success("Export berhasil!");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message || "Export gagal!");
        } else {
          message.error("Export gagal!");
        }
      })
      .finally(() => {
        setLoadingExport(false);
      });
  };
  const handleRange = (value) => {
    if (value !== null && value.length === 2) {
      const start = moment(value[0]).format("YYYY-MM-DD");
      const end = moment(value[1]).format("YYYY-MM-DD");
      setstartDate(start);
      setendDate(end);
    } else {
      setstartDate(null);
      setendDate(null);
    }
  };
  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setPagesize(pagination.pageSize);
    setSort({
      sort: sorter.field || "created_at",
      order: sorter.order || "descend",
    });
  };

  const columns = [
    {
      title: "ID QAD",
      dataIndex: "component_item",
      sorter: true,
    },
    {
      title: "Kode Supplier",
      dataIndex: "supplier_code",
      sorter: true,
    },
    {
      title: "Nama Supplier",
      dataIndex: "supplier_name",
      sorter: true,
    },
    {
      title: "GR No",
      dataIndex: "gr_no",
      sorter: true,
    },
    {
      title: "GR Date",
      dataIndex: "gr_date",
      sorter: true,
    },
    {
      title: "Tanggal Receive",
      dataIndex: "created_at",
      sorter: true,
      render: (tgl) => (tgl !== null ? moment(tgl).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "DN No",
      dataIndex: "dn_no",
      sorter: true,
    },
    {
      title: "Project",
      dataIndex: "project",
      sorter: true,
    },

    {
      title: "Part Number",
      dataIndex: "description2",
      sorter: true,
    },
    {
      title: "Part Name ",
      dataIndex: "description1",
      sorter: true,
    },
    {
      title: "Std Pack",
      dataIndex: "std_pack",
      sorter: true,
    },
    {
      title: "Kanban Order",
      // dataIndex: "kanban_order",
      render: (row) => {
        return row.kanban_order_rcvd + "/" + row.total_order_kanban;
      },
      // render: (data, columns) => {
      //   return `${columns.details.reduce(
      //     (total, num) => parseInt(num.qty_kanban) + total,
      //     0
      //   )} / ${data}`;
      // },
      sorter: false,
    },
    {
      title: "Qty Delivery",
      dataIndex: "qty_delivery",
      sorter: false,
      render: (data, row) => {
        console.log(row, "row");
        return `${row.kanban_order_rcvd} / ${row.kanban_order}`;
        // return `${row.details.reduce(
        //   (total, num) => parseInt(num.qty_kanban) + total,
        //   0
        // )} / ${row.kanban_order}`;
      },
    },
    {
      title: "Total Minus",
      dataIndex: "qty_delivery",
      sorter: false,
      render: (data, row) => {
        return row.kanban_order - row.kanban_order_rcvd;
        // return Math.abs(
        //     row.details.reduce(
        //       (total, num) => parseInt(num.qty_kanban) + total,
        //       0
        //     )-row.kanban_order
        // );
      },
    },

    // {
    //   title: "Jam Pelunasan",
    //   dataIndex: "jam_pelunasan",
    //   sorter: true,
    // },
    {
      title: "Storage",
      dataIndex: "storage",
      sorter: true,
    },
    {
      title: "Status Sync GR",
      dataIndex: "status_sync_gr",
      sorter: true,
      align: "center",
      width: 150,
      render: (item) => {
        return item ? (
          <CheckCircleOutlined style={{ color: "#00944b", fontSize: 30 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 30 }} />
        );
      },
    },
    {
      title: "Status Send GR",
      dataIndex: "status_send_gr",
      sorter: true,
      width: 150,
      align: "center",
      render: (item) => {
        return item ? (
          <CheckCircleOutlined style={{ color: "#00944b", fontSize: 30 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 30 }} />
        );
      },
    },
    {
      title: "Status Receive",
      dataIndex: "status_receive",
      align: "center",
      width: 150,
      sorter: true,
      render: (item, row) => {
        return parseInt(row.kanban_order_rcvd) ==
          parseInt(row.total_order_kanban) ? (
          <CheckCircleOutlined style={{ color: "#00944b", fontSize: 30 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 30 }} />
        );
      },
    },
    {
      title: "Status Match",
      dataIndex: "status_match",
      align: "center",
      width: 150,
      sorter: true,
      render: (item, record) => {
        // Normalisasi nilai status karena di backend ada beberapa format:
        // string "Matching", boolean true/false, atau kosong.
        const normalizedStatus =
          typeof item === "string" ? item.toLowerCase() : item;
        const qtyScanMatch = parseInt(record.qty_scan_kanban_match || 0);
        const qtyOrder = parseInt(record.kanban_order || 0);
        const receivedOrder = parseInt(record.kanban_order_rcvd || 0);
        const totalOrderKanban = parseInt(record.total_order_kanban || 0);
        // Tambahan kondisi: jika jumlah order terkirim (kanban_order_rcvd)
        // belum sama dengan total order kanban (total_order_kanban), maka
        // status match tetap dianggap tidak matching.
        const isOrderSame = receivedOrder === totalOrderKanban;
        // Fallback tampilan: jika qty scan sudah mencapai target order,
        // status matching hanya valid ketika order yang diterima juga sama.
        const isMatching =
          (item === true || normalizedStatus === "matching" ||
            (qtyOrder > 0 && qtyScanMatch >= qtyOrder)) &&
          isOrderSame;

        if (record.type_dn == "DN-MATERIAL") {
          return isMatching ? (
            <CheckCircleOutlined style={{ color: "#00944b", fontSize: 30 }} />
          ) : (
            <CloseCircleOutlined style={{ color: "red", fontSize: 30 }} />
          );
        } else {
          return (
            <MinusCircleOutlined style={{ color: "#8c8c8c", fontSize: 30 }} />
          );
        }
      },
    },
    // {
    //   title: "Keterangan",
    //   dataIndex: "keterangan",
    //   width: 250,
    //   sorter: true,
    // },
  ];

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="List GR Material"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          ></Card>
        </Col>
      </Row>

      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Row type="flex" gutter={[10, 20]} justify="space-around">
                <Col xs={24} md={12} lg={12}>
                  <Space wrap align="end" size="middle">
                    {/* Date Picker */}
                    <div>
                      <div style={{ marginBottom: "4px", fontSize: "14px" }}>
                        Sync Date
                      </div>
                      <DatePicker
                        value={date}
                        format="DD/MM/YYYY"
                        onChange={(val) => setDate(val)}
                        style={{ width: "150px" }}
                      />
                    </div>

                    {/* Sync GR Button */}
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "get-sap/master-gr-material"
                      ) && (
                        <Button
                          onClick={HandlegetQAD}
                          type="primary"
                          icon={<PlusOutlined />}
                          style={{ marginTop: "23px" }} // Sejajar dengan DatePicker
                        >
                          Sync GR
                        </Button>
                      )}

                    {/* Export Button */}
                    {buttonAccess &&
                      buttonAccess.find(
                        (x) => x.url === "gr-material/export"
                      ) && (
                        <Button
                          loading={loadingExport}
                          onClick={exportGRMaterial}
                          type="primary"
                          icon={<ExportOutlined />}
                          style={{ marginTop: "23px" }} // Sejajar dengan DatePicker
                        >
                          Export
                        </Button>
                      )}
                  </Space>
                </Col>
                <Col xs={24} md={12} lg={12}>
                  <Row
                    gutter={[10, 10]}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Col xs={24} md={8} lg={8}>
                      <RangePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        placeholder={["Start Date", "End Date"]}
                        onChange={(val) => handleRange(val)}
                      />
                    </Col>

                    <Col xs={24} md={16} lg={16}>
                      <Search
                        placeholder="cth: G01-02-C, Nama Supplier, L02XX atau DN0D240223L0284xxx"
                        style={{ width: "100%" }}
                        onSearch={(value) => handleSearch(value)}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col xs={24}>
                  <Table
                    scroll={{ x: 2500, y: 500 }}
                    columns={columns}
                    // dataSource={grmaterials.data || []}
                    // dataSource={(grmaterials.data || []).filter(item => item !== null && item !== undefined)}
                    dataSource={(grmaterials.data || []).filter(Boolean)}
                    rowKey={(data) => data._id}
                    onChange={handleTableChange}
                    pagination={{
                      pageSize: pageSize,
                      current: page,
                      total: totalGR,
                      showSizeChanger: true,
                    }}
                    loading={loading}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default SPListGRMaterial;
